import { Tooltip } from '@mui/material';
import styled, { css, keyframes } from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { THEME } from '../../../../../../themes';

const getGrowUpAnimation = (height: string) => {
  return keyframes`
      from {
          height: 24px;
      }
      to {
          height: ${height};
      }
      `;
};

export const TooltipBubble = withStyles({
  tooltip: {
    display: 'flex',
    color: `${THEME.COLORS.PRIMARY_DARK}`,
    backgroundColor: `${THEME.COLORS.LIGHT_GREY}`,
    borderRadius: '24px 24px 5px 24px',
    width: 'auto !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'center',
    height: 'auto',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: 'normal',
    letterSpacing: '0.4px',
    border: `solid 2px ${THEME.COLORS.PURE_WHITE}`,
    position: 'absolute',
    top: '-10px',
    right: '-6px',
  } as const,
})(Tooltip);

export const BarsContainer = styled.div`
 display: flex;
 align-items: end;
 margin-top: auto;
`;

export const Bar = styled.div<{
    color:string,
    height: string,
    isEnableAnimation: boolean,
}>`
  min-height: 24px;
  max-height: 90px;
  display: flex;
  justify-content: center;
  align-items: end;
  padding: ${THEME.SPACING.MICRO};
  width: 24px;
  height: ${({ height }) => height};
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-color: ${({ color }) => color};
  margin-left: ${THEME.SPACING.MICRO};
  animation: ${({ height, isEnableAnimation }) => isEnableAnimation ?
    css`${getGrowUpAnimation(height)} 1200ms cubic-bezier(0.85, 0, 0.15, 1)` :
    'none'};
`;
